/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-legend-reverse',
  templateUrl: './theme-option-legend-reverse.component.html',
  styleUrls: ['./theme-option-legend-reverse.component.css']
})
export class ThemeOptionLegendReverseComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'legend_reverse';
  showDetails: boolean;

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: boolean, type?: ChartType) {
    this.themeOptions.setOption(this.optionType, value, type ? [type] : undefined);
  }

}
